import React from "react";
import Headers from "../LandingPage/Components/Headers";
import Contact from "../LandingPage/Components/Contact";
import Thankyou from "./Thankyou";

export default function Parent() {
  return (
    <div className="flex flex-col min-h-screen bg-white">

      {/* Courses Section */}
      <main className="flex-grow">
        <Thankyou />
      </main>

      {/* Contact / Footer */}
      <footer className="w-full bg-gray-100 border-t">
        <Contact />
      </footer>
    </div>
  );
}
